import { render, staticRenderFns } from "./digitalTransformateDetail.vue?vue&type=template&id=afd74722&scoped=true&"
import script from "./digitalTransformateDetail.vue?vue&type=script&lang=js&"
export * from "./digitalTransformateDetail.vue?vue&type=script&lang=js&"
import style0 from "./digitalTransformateDetail.vue?vue&type=style&index=0&id=afd74722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd74722",
  null
  
)

export default component.exports